import { WeatherIconKey } from "./weatherIcons";

/**
 * Ícone do dia a partir de chuvaMm (mm/dia) da API.
 * Ícones locais disponíveis: clear-day | partly-cloudy-day | cloudy | rain
 *
 * 0            → clear-day
 * > 0 e < 2.5  → partly-cloudy-day (garoa / muito pouca)
 * 2.5 a < 10   → cloudy (chuva leve)
 * 10 a < 30    → rain (chuva moderada)
 * >= 30        → rain (chuva forte; sem extreme-rain no bundle)
 */
export function getDailyWeatherIcon(mmChuva: number | null | undefined): WeatherIconKey {
  const mm = mmChuva == null || Number.isNaN(Number(mmChuva)) ? 0 : Number(mmChuva);

  if (mm <= 0) return "clear-day";
  if (mm < 2.5) return "partly-cloudy-day";
  if (mm < 10) return "cloudy";
  return "rain";
}
